import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
  CompensationCategoryConditionEnum,
  CompensationCategoryModel
} from '@bo-client/activation-management/shared/models/compensationCategoryModel';
import { PowerGenerationSourceEnum } from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';

@Injectable({
  providedIn: 'root'
})
export class CompensationCategoriesService {
  public form: FormGroup;

  constructor(private fb: FormBuilder) {}

  createCompensationCategoryForm(data: CompensationCategoryModel) {
    return this.fb.group({
      id: [data.id],
      name: [data.name],
      powerRange: [data.powerRange],
      generationSource: [data.generationSource],
      compensationAmount: [data.compensationAmount],
      isFullFeed: [data.isFullFeed],
      validFrom: [data.validFrom],
      validTo: [data.validTo]
    });
  }

  compensationCategoryPowerRangeType: any[] = [
    {
      value: CompensationCategoryConditionEnum.None,
      displayName: 'Kein Leistungsbereich'
    },
    {
      value: CompensationCategoryConditionEnum.BETWEEN_0KW_10KW,
      displayName: '0 - 10 kW'
    },
    {
      value: CompensationCategoryConditionEnum.BETWEEN_10KW_40KW,
      displayName: '10 - 40 kW'
    },
    {
      value: CompensationCategoryConditionEnum.BETWEEN_40KW_750KW,
      displayName: '40 - 750 kW'
    },
    {
      value: CompensationCategoryConditionEnum.BETWEEN_40KW_100KW,
      displayName: '40 - 100 kW'
    },
    {
      value: CompensationCategoryConditionEnum.BETWEEN_100KW_400KW,
      displayName: '100 - 400 kW'
    },
    {
      value: CompensationCategoryConditionEnum.BETWEEN_400KW_1000KW,
      displayName: '400 - 1000 kW'
    },
    {
      value: CompensationCategoryConditionEnum.BETWEEN_40KW_1000KW,
      displayName: '40 - 1000 kW'
    }
  ];
}
